<template>
    <el-dialog
        title="提示"
        :visible="dialogVisible"
        :before-close="back"
        width="500px"
    >
        <h3>请打开或者下载最新版证书助手</h3>
        <p>
            <span>请确认是否插入USBkey 或者</span>
            <a
                class="blue-text pointer"
                href="https://xkapp.sheca.com/pages/download.html"
                target="_blank"
                ><u><b>下载最新版证书助手</b></u></a
            >
        </p>
        <span slot="footer" class="dialog-footer">
            <el-button type="primary" @click="back">确 定</el-button>
        </span>
    </el-dialog>
</template>

<script>
export default {
    data() {
        return {};
    },
    props: {
        showUkeyDialog: Boolean
    },
    computed: {
        dialogVisible: {
            get() {
                return this.showUkeyDialog;
            },
            set(val) {
                this.$emit("update:showUkeyDialog", val);
            }
        }
    },
    methods: {
        back() {
            this.dialogVisible = false;
        }
    }
};
</script>
